/* eslint-disable */
import React, { useCallback, useEffect, useState } from "react";
import { BeijingMotor } from '@request'
import ModuleListPop from '@component/2024beijing/moduleListPop'
import NavBar from '@component/2024beijing/navBar'
import Map from "../../components/map";
import Toast from 'antd-mobile/lib/toast'
import 'antd-mobile/lib/toast/style/index.css'
import { tools } from "newcar-ui/output/cjs/utils";
import { appMethods } from "newcar-ui/output/es/appMethods";
tools.addVconsole();
const imageList = [
  '//icon.xgo-img.com.cn/topic/24040817/2.png',
  '//icon.xgo-img.com.cn/topic/24040717/dd2.png',
  '//icon.xgo-img.com.cn/topic/24040716/yy.png',
  '//icon.xgo-img.com.cn/topic/24040716/dsadqdq.png',
  '//icon.xgo-img.com.cn/topic/24040716/hctj.png',
  '//icon.xgo-img.com.cn/topic/24040716/czrl.png',
  '//icon.xgo-img.com.cn/topic/24040716/qwj.png',
  '//icon.xgo-img.com.cn/topic/24040716/xcyg.png',
  ' //icon.xgo-img.com.cn/topic/24041019/tzzzopen.png',
  '//icon.xgo-img.com.cn/topic/24040716/xcsp.png',
  '//icon.xgo-img.com.cn/topic/24040714/ditu.png',
  '//icon.xgo-img.com.cn/topic/24040811/dc.png',
  '//icon.xgo-img.com.cn/topic/24041916/che.png',
  '//icon.xgo-img.com.cn/topic/24041916/che1.png',
  '//icon.xgo-img.com.cn/topic/24041916/chejieshengdian.png',
  '//icon.xgo-img.com.cn/topic/24041916/liba.png',
  '//icon.xgo-img.com.cn/topic/24041916/tingchewei.png',
  '//icon.xgo-img.com.cn/topic/24041916/tuwenkuanxun.png',
  '//icon.xgo-img.com.cn/topic/24041916/zhanpai.png',
  '//icon.xgo-img.com.cn/topic/24041916/zhanpai1.png',
  '//icon.xgo-img.com.cn/topic/24041916/zhibo.png',
]
function preventDefault_(e) {
  e.preventDefault();
}
function addPrevent() {
  window.addEventListener('touchmove', preventDefault_, { passive: false })
}
function removePrevent() {
  window.removeEventListener('touchmove', preventDefault_, { passive: false })
}
window.loadImageNumber_ = 0;
let App = () => {
  const [is58App, setIs58App] = useState(tools.is58App());
  const [popModuleShow, setPopModuleShow] = useState(false)
  const [popModuleList, setPopModuleList] = useState([

  ])
  const [moduleType, setModuleType] = useState(1)
  const [navIndex, setNavIndex] = useState(sessionStorage.getItem('currentTab') || ('0-' + Date.now()))
  const [wrapIndex, setWrapIndex] = useState(sessionStorage.getItem('currentTab') || ('0-' + Date.now()));
  const [moduleList, setModuleList] = useState([])
  const [popTime, setPopTime] = useState(0)
  const [gameUrl, setGameUrl] = useState('https://www.baidu.com');
  const height = window.innerHeight;
  const width = window.innerWidth;

  const [initImageStatus, setInitImageStatus] = useState(false);
  const [tipWord, setTipWord] = useState('已经加载0%');
  const [showMask, setShowMask] = useState(true)
  const loadImage = useCallback((url) => {
    return new Promise((resolve, reject) => {
      let image = new Image();
      image.onload = function () {
        window.loadImageNumber_ += 1;
        let percent = (window.loadImageNumber_ / imageList.length * 100).toFixed(0)
        setTipWord('已经加载' + percent + '%')
        resolve(true)
      }
      image.src = url;
    })
  }, [])
  const initImage = useCallback((type) => {
    const listPromise = imageList.map((item, index) => {
      return loadImage(item);
    })
    Promise.all(listPromise).then(() => {
      setInitImageStatus(true);
      localStorage.setItem('imageCache', 'true');
    }).catch((e) => {
      console.log('加载错误')
    })
  }, [width])
  useEffect(() => {
    if (width < 700) {
      addPrevent();
    }
    if (is58App) {
      appMethods.loadAPPSDK().then(() => {
        window.XINCHEAPP.invoke(
          "toggle_gesture",
          {
            cmd: "off",
            edge_paning: true,
            webview_paning: "off"
          },
          function (a) {
            console.log(a);
          }
        );
      });
    }
    init();
    const shareInfo = {
      title: "2024北京车展-58云带看",
      desc: "2024北京国际车展一手资讯获取，趣味互动参与，由58新车提供。",
      imgurl: "https://icon.xgo-img.com.cn/topic/24040219/meishi_20240402_nx6Pp3eR7w.jpg",
      success: function (res) {
        tools.sendClickStatistics_wmda(339, {
          actionType: '24biae-share-click'
        })
      },
      fail: function (err) {
        console.log("cuowu", err);
      },
      wbShareClickFun: function (ress) {
        console.log("wb", ress);
      }
    };
    tools.sendPageWMDAShow({
      eventid: 335,
      pagetype: '24biae-map',
      page: '24biae-map'
    });
    tools.pageShare(shareInfo);

    initImage()

  }, [])
  const init = () => {
    BeijingMotor.getDefaultInfo().then((res) => {
      const { status, result, message } = res;
      if (result) {
        const { moduleList, bubbleTime } = result;
        setModuleList(moduleList);
        setPopTime(bubbleTime);
        const styleEl = document.createElement('style');
        styleEl.innerHTML = `#root{
          height:${height || '0'}px!important;}.like-heart {
            animation: likeBubble ${result.bubbleTime}s infinite linear;
          }`;
        document.head.appendChild(styleEl);
      }
    })
  }

  const getModuleInfo = useCallback((type, item) => {
    if (type == 9 || type == 6) {
      // 跳转页面
      if (is58App) {
        appMethods.goto(item.wbmainUrl)
      } else {
        window.location.href = item.url;
      }
    } else if (type == 10) {
      sessionStorage.setItem('type', type);
      getLiveModuleInfo(type)
    } else {
      sessionStorage.setItem('type', type);
      BeijingMotor.getMoudleData({ id: type }).then((res) => {
        const { status, result, message } = res;
        if (status == 0) {
          if (result.status == 1) {
            setModuleType(type)
            setPopModuleList(result);
            setPopModuleShow(true)
          } else {
            Toast.info(result.statusText)
          }

        } else {
          Toast.info(message)
        }
      })
    }
  }, [gameUrl])

  const getLiveModuleInfo = useCallback((type) => {
    BeijingMotor.getLiveModuleData({ id: type }).then((res) => {
      const { status, result, message } = res;
      if (result) {
        // console.log('数据', result.list)
        setModuleType(type)
        setPopModuleList(result)
        setPopModuleShow(true)
      }
    })
  }, [])

  const onPopCloseFn = () => {
    // console.log('关闭弹窗')
    setPopModuleShow(false)
    // pop弹窗设置了 hidden 保证局部滚动正常，消失的时候重置 body
    document.body.style.overflow = 'auto'
  }

  const onNavBarChange = useCallback((tab, index) => {
    if (index != 2) {
      setShowMask(true);
      if (width < 700) {
        addPrevent();
      }
    } else {
      if (width < 700) {
        removePrevent();
      }
    }
    let currentTab = index + '-' + Date.now();
    sessionStorage.setItem('currentTab', currentTab);
    setWrapIndex(currentTab)
  }, [])
  const changeTab = useCallback((tab, index) => {
    sessionStorage.setItem('currentTab', index);
    setNavIndex(index)
  }, [])
  const maskTouch = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation()
    return false;
  }, []);
  const maskCallback = useCallback((e) => {
    setShowMask(false);
  }, []);
  useEffect(() => {
    let index = wrapIndex.split('-')[0]
    if (index != 2) {
      if (popModuleShow == true) {
        if (width < 700) {
          removePrevent();
        }
      } else {
        if (width < 700) {
          addPrevent();
        }
      }
    }
  }, [popModuleShow, wrapIndex])
  return <>
    {/* <TestGame /> */}
    {/* <div className="mapwrap">
      <div className="demo-click" onClick={() => { getModuleInfo(1) }}>新车预告</div>
      <div className="demo-click" onClick={() => { getModuleInfo(2) }}>新车推荐</div>
      <div className="demo-click" onClick={() => { getModuleInfo(3) }}>车展快讯</div>
      <div className="demo-click" onClick={() => { getModuleInfo(4) }}>新车实拍</div>
      <div className="demo-click" onClick={() => { getModuleInfo(5) }}>车展趣闻</div>
      <div className="demo-click" onClick={() => { getModuleInfo(6) }}>车展热聊</div>
      <div className="demo-click" onClick={() => { getModuleInfo(7) }}>品牌专访</div>
      <div className="demo-click" onClick={() => { getModuleInfo(8) }}>好车推荐</div>
      <div className="demo-click" onClick={() => { getLiveModuleInfo(9) }}>现场直播</div>
    </div> */}
    {width < 700 && <NavBar
      onTabChange={onNavBarChange}
      currentBar={navIndex}></NavBar>}

    {popModuleShow &&
      <ModuleListPop
        title="现场直播"
        sourceData={popModuleList}
        type={moduleType}
        closeFn={onPopCloseFn}
      ></ModuleListPop>}
    <div id='bake' style={{ height: '1rem', visibility: 'hidden', position: 'absolute', zIndex: -99 }}></div>
    {showMask && width < 700 && <div className="fixed-mask" onTouchStart={maskTouch}></div>}
    {initImageStatus ? moduleList.length > 0 && popTime > 0 &&
      <Map Height={height} Width={width} navIndex={wrapIndex} moduleList={moduleList} getModuleInfo={getModuleInfo} popTime={popTime} changeTab={changeTab} maskCallback={maskCallback} is58App={is58App}></Map> :
      <div className="map-tips">
        <span>资源{tipWord}</span>
      </div>}

  </>;
};

export default App;
